// Admin shell: sidebar nav + layout chrome.
const m: Record<string, string> = {
  'Tableau de bord': 'Dashboard',
  'Commandes': 'Orders',
  'Clients': 'Customers',
  'Couvertures': 'Covers',
  'Layout Templates': 'Layout Templates',
  'Livraison AMEEX': 'AMEEX Delivery',
  'Relances': 'Follow-ups',
  'Impression': 'Printing',
  'Stock': 'Stock',
  'Comptabilité': 'Accounting',
  'Paramètres': 'Settings',
  'Déconnexion': 'Log out',
  'Connecté en tant que': 'Signed in as',
  'Admin Storiz': 'Storiz Admin',
  // App shell (2026-10-01): menu groups, bottom tabs, « More » sheet, gestures.
  'Au quotidien': 'Daily',
  'Gestion': 'Business',
  'Catalogue': 'Catalogue',
  'Système': 'System',
  'Scanner': 'Scanner',
  'Accueil': 'Home',
  'Compta': 'Accounting',
  'Modèles': 'Templates',
  'Équipe': 'Team',
  'Alertes': 'Alerts',
  'Plus': 'More',
  'Menu': 'Menu',
  'Navigation principale': 'Main navigation',
  'Compte': 'Account',
  'Actualisation…': 'Refreshing…',
  'Produits': 'Products',
  'Utilisateurs': 'Users',
  // Night mode (2026-10-02): « More » and Settings › Appearance.
  'Apparence': 'Appearance',
  'Passer en mode clair': 'Switch to light mode',
  'Passer en mode sombre': 'Switch to dark mode',
  'Auto': 'Auto',
  'Clair': 'Light',
  'Sombre': 'Dark',
  'Suit le réglage du téléphone — sombre en ce moment.': 'Follows your phone — dark right now.',
  'Suit le réglage du téléphone — clair en ce moment.': 'Follows your phone — light right now.',
  'Mémorisé sur cet appareil.': 'Remembered on this device.',
  'Enregistré pour votre compte — partout, éditeur compris.': 'Saved to your account — everywhere, the editor included.',
  'Clair, sombre, ou comme le téléphone. Enregistré pour votre compte : il vous suit partout, éditeur et aperçu compris. Les photos, les pages et les couvertures ne changent jamais de couleur.':
    'Light, dark, or like your phone. Saved to your account: it follows you everywhere, the editor and the preview included. Photos, pages and covers never change colour.',
};
export default m;
